<div class="m-2">
    <mat-progress-bar class="progress progress-lg" mode="indeterminate"></mat-progress-bar>
</div>
